import Teami from "../images/teami-screen.png";
import Mybyk from "../images/mybyk-screen.png";
import Cardsplug from "../images/Mockup.png";

const workCardData = [
  {
    id: 1,
    clsName: "gradient-primary-shape",
    title: "Teami",
    description: `<p>The project was instituted by our highly qualified team in association with MongoDB Atlas. It supports huge traffic and our team ensured that it was completed before the stipulated time which made it one of the fastest delivered project for a Shopify Client.</p>
        <ul><li>Daily visits 300k</li><li>AOV $100+</li><li>ReCharge subscription integration with custom checkouts</li></</ul>`,
    image: Teami,
    imgeWidth: '404',
    imageHeight: '310'
  },
  {
    id: 2,
    clsName: "gradient-tertiary-shape",
    title: "Cardsplug",
    description: `<p>One of our stellar projects that pushed the boundaries of Shopify, showing us what it is capable of if used correctly From imagining the custom builder in place to execution - this pioneer product gives the most value to our clients and us.</p>
        <ul><li>Daily 110k+ visits</li><li>AOV $70+</li><li>Super fun and interactive builder which makes dream cards for the customers on a daily basis</li></</ul>`,
    image: Cardsplug,
    imgeWidth: '404',
    imageHeight: '310'
  },
  {
    id: 3,
    clsName: "gradient-secondary-shape",
    title: "MYBYK Bike Sharing Program",
    description:
      "<p>MYBYK is India's leading bike sharing program spread across <u>13</u> cities in India and growing daily. It has more than <u>2000+</u> hubs across the cities and handles <u>10k</u> bicycles with a monthly transaction on the upside of <u>500k</u>. Our team built this from the ground up, India's very own - first ever Cycle Sharing Programme. It makes use of multitudes of technologies to get it working smoothly day in and day out.</p>",
    image: Mybyk,
    imgeWidth: '390',
    imageHeight: '407'
  },
];

export default workCardData;
